import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Card from '/component/base/Card';
import Icon from '/component/base/Icon';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {withTheme} from '/provider/ThemeProvider';

import {styles} from './Banner.style';

export const Banner = ({
  getTheme = noop,
  children = null,
  alertLevel = 'info',
  useCompetency = false,
  bannerClose = noop,
  verticalBanner = false,
  style: styleProp,
  alertSucessBg,
  closeIconTestID,
}: any) => {
  let style = {...styles.base};

  if (alertLevel === 'low') {
    style = {...style, ...styles.low};
  } else if (alertLevel === 'info') {
    style = {...style, ...styles.info};
  } else if (alertLevel === 'important') {
    style = {...style, ...styles.important};
  } else if (alertLevel === 'success') {
    style = {...style, ...styles.success};
  } else if (alertLevel === 'error') {
    style = {...style, ...styles.error};
  }

  if (useCompetency) {
    style = {...style, ...getTheme('competency.bannerColors.base')};
  }
  const bannerStyleArray = [
    verticalBanner ? styles.verticalBase : styles.horizontalBorder,
    style,
    styleProp?.base,
    alertSucessBg ? styles.backgroundSucess : null,
  ].filter(Boolean);

  return verticalBanner ? (
    <Card
      testID="banner"
      hasBorder={false}
      style={bannerStyleArray}
      accessible={false}>
      <View style={[styles.verticalBorder, style]} />
      <View style={styles.verticalContent}>
        <View style={styles.text}>{children}</View>
        {bannerClose !== noop && (
          <View style={styles.verticalCloseButton}>
            <TouchableOpacity
              onPress={bannerClose}
              testID={closeIconTestID}
              accessibilityRole="button"
              accessibilityLabel={closeIconTestID || 'Close message banner'}>
              <Icon
                name="close"
                style={styles.closeButtonIcon}
                accessible={false}
                importantForAccessibility="no-hide-descendants"
              />
            </TouchableOpacity>
          </View>
        )}
      </View>
    </Card>
  ) : (
    <Card
      testID="banner"
      hasBorder={false}
      style={bannerStyleArray}
      accessible={false}>
      <View style={styles.closeButton}>
        <TouchableOpacity
          onPress={bannerClose}
          testID={closeIconTestID}
          accessibilityRole="button"
          accessibilityLabel={closeIconTestID || 'Close message banner'}>
          <Icon
            name="close"
            style={styles.closeButtonIcon}
            accessible={false}
            importantForAccessibility="no-hide-descendants"
          />
        </TouchableOpacity>
      </View>
      {children}
    </Card>
  );
};

export default withTheme(Banner);
